import React from 'react';

import { OnlyInput } from '../../../components/common/atom/Input';
import { Flex } from '../../../components/common/atom/Layout';
import { Button } from '../../../components/common/atom/Button';
import { Text } from '../../../components/common/atom/Text';
import {
  Padding,
  VerticalPadding,
} from '../../../components/common/atom/Padding';
import { TextArea } from '../../../components/common/atom/Textarea';
import { DaumPostcode } from '../../../components/common/molecules/DaumPostCode';
import { InputForm } from '../../../components/common/organism/InputForm';
import { InputRadioList } from '../../../components/common/organism/InputRadioList';
import { TextareaWithHeart } from '../../../components/common/organism/TextareaWithHeart';
import { Layout } from '../../../components/common/template/OrderTemplate';
import useGetDaumPostCode from '../../../Hooks/useGetDaumPostCode';

export const NameMobileInputs = ({
  formData = DELIVERY_INFO_DATA,
  children = undefined,
  onChange = undefined,
  state = {
    name: '',
    nameError: null,
    mobile: '',
    mobileError: null,
  },
}) => {
  return (
    <InputForm
      formData={formData}
      onChangeValue={onChange}
      onSubmit={undefined}
      state={state}
    >
      {children}
    </InputForm>
  );
};

export const DELIVERY_INFO_DATA = [
  {
    mainIconName: 'person',
    placeholder: '예) 베이비페이스',
    type: 'text',
    name: 'name',
  },
  {
    mainIconName: 'smartphone',
    placeholder: '예) 01012345678',
    type: 'number',
    name: 'mobile',
  },
];

export const DeliveryInfo = ({
  onAddress = ({ address, zipcode }) => undefined,
  onChange = undefined,
  shipmentRequired = true,
  state = {
    name: '',
    nameError: null,
    mobile: '',
    mobileError: null,
    address: '',
    zipcode: '',
    detailAddress: '',
    detailAddressError: null,
  },
}) => {
  const { handleAddress, closeDaumPostcode } = useGetDaumPostCode(onAddress);

  return (
    <NameMobileInputs
      onChange={onChange}
      formData={DELIVERY_INFO_DATA}
      state={state}
    >
      {shipmentRequired && <>
        <Flex padding="0.625rem 0">
          <OnlyInput
            width="190px"
            placeholder="우편번호"
            value={state.zipcode}
            readOnly
            flex={2}
            background="grey"
          />
          <Button
            color="caption"
            onClick={handleAddress}
            style={{ marginLeft: '0.938rem', flex: 1 }}
          >
            <Text size={14}>주소찾기</Text>
          </Button>
        </Flex>
        <OnlyInput
          placeholder="기본주소"
          value={state.address}
          readOnly
          background="grey"
        />
        <OnlyInput
          name="detailAddress"
          placeholder="상세주소"
          value={state.detailAddress}
          onChange={onChange}
          background="white"
          active={state.detailAddressError}
        />
        {state.detailAddressError && (
          <Text color="orangePink" size="14" style={{ marginTop: '5px' }}>
            *{state.detailAddressError}
          </Text>
        )}
        <DaumPostcode closeDaumPostcode={closeDaumPostcode} />
      </>
    }
    </NameMobileInputs>
  );
};

const BabyGenderRadio = ({ babyGender, onChange, disabled }) => {
  return (
    <>
      <Flex justifyContent="flex-start" padding="0.625rem 0">
        <Text size={14} weight="medium" style={{ marginRight: '1.375rem' }}>
          아기성별 (선택)
        </Text>
        <InputRadioList
          radioData={[
            {
              label: '남',
              value: 'MALE',
              checked: babyGender === 'MALE',
              disabled,
              onChange,
            },
            {
              label: '여',
              value: 'FEMALE',
              checked: babyGender === 'FEMALE',
              disabled,
              onChange,
            },
          ]}
        />
      </Flex>
      <Text size={12} color="brownGrey">
        아기 성별은 참고용이며 분석결과에 직접적인 영향을 주지 않습니다.
      </Text>
    </>
  );
};

const HospitalNameInput = ({ onChange, disabled, hospitalName }) => (
  <Flex justifyContent="flex-start" padding="1.25rem 0 0">
    <Text
      size={14}
      weight="medium"
      style={{ marginRight: '1.375rem', flex: 1 }}
    >
      병원이름 (선택)
    </Text>
    <OnlyInput
      name="hospitalName"
      onChange={onChange}
      disabled={sessionStorage.be_hospital || disabled}
      placeholder="병원 이름을 입력하세요"
      flex={2}
      value={hospitalName}
    />
  </Flex>
);

export const BabyfaceFirstInfo = ({
  title,
  children,
  babyGender,
  hospitalName,
  onChangeBabyGender,
  onChangeHospitalName,
  note,
  onChangeNote,
  disabled,
  required,
}) => (
  <Layout title={title} required={required}>
    {children}
    <HospitalNameInput
      onChange={onChangeHospitalName}
      hospitalName={hospitalName}
      disabled={disabled}
    />
    <BabyGenderRadio
      onChange={onChangeBabyGender}
      babyGender={babyGender}
      disabled={disabled}
    />
    <VerticalPadding padding={10}>
      <Text size={14} weight="medium">
        고객 전달 사항 (선택)
      </Text>
    </VerticalPadding>
    <TextArea
      name="note"
      placeholder="추가 전달 사항이 있으실 경우, 작성해 주세요"
      value={note}
      onChange={onChangeNote}
      maxLength={255}
      disabled={disabled}
      updateAvailable={!disabled}
    />
    <VerticalPadding padding={10}>
      <Text size={12} color="brownGrey">
        * 베이비페이스는 입체 초음파에서 표현된 정보 (이목구비 형태 등)를 토대로
        머리 모양, 눈썹, 피부 톤, 명암 등 초음파에 없는 정보가 추가 됩니다.
      </Text>
    </VerticalPadding>
  </Layout>
);

export const MessageToBaby = ({
  disabled,
  onClickAddHeart,
  onChangeMessage,
  message,
}) => (
  <TextareaWithHeart
    message={message}
    onClickAddHeart={onClickAddHeart}
    onChange={onChangeMessage}
    disabled={disabled}
    maxLength={20}
    placeholder={`- 남기고 싶은 예시: 콩콩아 사랑해!\n- 아기 태명, 출산예정일, 날짜, 보고싶어 등등\n- 20자 이내로 입력해주세요!`}
  />
);
export const BabyfaceSecondInfo = ({ title, required, children }) => (
  <Layout title={title} required={required}>
    {children[0]}
    <Padding top={30} bottom={10}>
      <Text weight="medium" size={14}>
        아기에게 보내는 메시지, 사진 하단에 들어갈 문구 (선택)
      </Text>
    </Padding>
    {children[1]}
  </Layout>
);
